<script>
import EditFieldModal from './EditFieldModal.vue';

export default {
  components: {
    EditFieldModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonTextMobile: {
      type: String,
      default: '',
    },
    buttonLink: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'save', 'delete'],
  computed: {
    hasButton() {
      return !!this.buttonText;
    },
    fields() {
      return [
        {
          key: 'buttonText',
          label: 'Button Text (Desktop)',
          placeholder: 'Enter button text for desktop',
          value: this.buttonText,
          type: 'textarea',
          rows: 2,
        },
        {
          key: 'buttonTextMobile',
          label: 'Button Text (Mobile)',
          placeholder: 'Enter button text for mobile',
          value: this.buttonTextMobile,
          type: 'textarea',
          rows: 2,
        },
        {
          key: 'buttonLink',
          label: 'Button Link',
          placeholder: 'https://example.com',
          value: this.buttonLink,
          type: 'input',
        },
      ];
    },
  },
  methods: {
    handleSave(values) {
      this.$emit('save', values);
    },
    handleClose() {
      this.$emit('close');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<template>
  <EditFieldModal
    :visible="visible"
    modal-title="Edit Button"
    :fields="fields"
    :show-delete="hasButton"
    @save="handleSave"
    @close="handleClose"
    @delete="handleDelete"
  />
</template>
